/** Tenant-scoped instrument API base (`instrumentId` unique per tenant). */
export function instrumentApiPath(instrumentId: string, suffix = ''): string {
  const base = `/api/v1/instruments/${encodeURIComponent(instrumentId)}`
  if (!suffix) return base
  const pathSuffix = suffix.startsWith('/') ? suffix : `/${suffix}`
  return `${base}${pathSuffix}`
}

/** Campaign-scoped instrument metadata (fallback when tenant-scoped GET is unavailable). */
export function campaignInstrumentPath(campaignId: string, instrumentId: string): string {
  return `/api/v1/campaigns/${encodeURIComponent(campaignId)}/instruments/${encodeURIComponent(instrumentId)}`
}
